import axios from "axios";
//#region src/request-engine.ts
const getBaseUrl = ({ port, domainsForStages, stage }) => {
	if (port) return `http://localhost:${port}`;
	const url = domainsForStages[stage];
	if (url) return url;
	throw new Error("Expected either stage=[\"staging\"|\"prod\"] or port=<Int>");
};
const initEngine = ({ stage = "prod", port, domainsForStages }) => axios.create({
	baseURL: getBaseUrl({
		domainsForStages,
		stage,
		port
	}),
	validateStatus: () => true
});
const addAuthenticationInterceptor = (engine, { token, generateToken }) => {
	if (!token && !generateToken) throw new Error("Either \"token\" or \"generateToken\" must be specified");
	engine.interceptors.request.use(getAuthenticationInterceptor({
		token,
		generateToken
	}));
};
const getAuthenticationInterceptor = ({ token, generateToken }) => async (requestConfig) => {
	const apiKey = generateToken ? await generateToken() : token;
	if (apiKey) requestConfig.headers.set("x-api-key", apiKey);
	return requestConfig;
};
const createRequesterComponent = ({ token, generateToken, ...options }) => {
	const engine = initEngine(options);
	addAuthenticationInterceptor(engine, {
		token,
		generateToken
	});
	return engine;
};
//#endregion
//#region src/people-insights-dashboard-api-client.ts
const getClient = (options) => {
	const engine = createRequesterComponent({
		...options,
		domainsForStages: {
			prod: "https://insights.locuslabs.com",
			staging: "https://staging.insights.locuslabs.com"
		}
	});
	return {
		options,
		ping: () => engine.get("/ping"),
		generateEmbeddableDashboards: () => engine.get("/embeddable-dashboards")
	};
};
//#endregion
export { getClient };

//# sourceMappingURL=index.mjs.map